import { getGlobalCountry } from '@/atoms/countryState';

import { apiClient, baseForPdf } from '../apiClients';
import { fetchAndCache } from '../../components/shared/CacheStroage';
import { Endpoints } from '../../network';

export const getAllProducts = async (
  page: number,
  category_id: number,
  book_type?: string | undefined,
  title?: string,
  limit?: number,
  is_preorder?: boolean,
) => {
  const queryParams = new URLSearchParams({
    category_id: category_id.toString(),
    page: page.toString(),
    ...(book_type && { book_type }),
    ...(title?.trim() && { name: title }),
    ...(limit && { perPage: limit?.toString() }),
    ...(typeof is_preorder !== 'undefined' && {
      is_preorder: is_preorder.toString(),
    }),
  });

  const url = `${Endpoints.getAllProducts}?${queryParams}`;

  const apiCall = async () => {
    const response = await apiClient.get(url);
    return response?.data;
  };

  return fetchAndCache(apiCall, url, page);
};

export const getAllProductsRewards = async (
  page: number,
  category_id: number,
  limit?: number,
) => {
  const queryParams = new URLSearchParams({
    sub_category_id: category_id.toString(),
    page: page.toString(),
    ...(limit && { perPage: limit?.toString() }),
  });

  const url = `${Endpoints.getAllProducts}/claimable?${queryParams}`;

  const response = await apiClient.get(url);
  return response?.data;
};

export const getProductsDetails = async (slug: string) => {
  const url = `${Endpoints.productDetails}/${slug}`;

  const response = await apiClient.get(url);

  return response?.data;
};
export const getProductDetails = async (productId: string) => {
  const url = `${Endpoints.productDetail}/${productId}`;

  const response = await apiClient.get(url);

  return response?.data;
};

export const getProductDetailsSSR = async (productId: string) => {
  const urlWithQuery = `${Endpoints.productDetail}/${productId}`;
  const country = getGlobalCountry() || 'IN';
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_READER_URL}${urlWithQuery}`,
      {
        cache: 'force-cache',
        headers: { country: country.countryCode as string },
      },
    );

    if (response.status === 404) {
      throw { code: 404 };
    }

    if (!response.ok) {
      throw new Error(`Error fetching product details: ${response.statusText}`);
    }

    const data = await response.json();
    return data?.data;
  } catch (error) {
    console.error('Fetch error (SSR getProductDetails):', error);
    throw error;
  }
};

export const subscribeForUpcomingBooks = async (bookId: string) => {
  const url = `${Endpoints.comingSoonSubscribe}`;

  const response = await baseForPdf.post(url, { bookId });

  return response?.data;
};
